import { api } from './api';

/**
 * Billing
 */
export function getInvoices(params) {
  return api.get(`/billing/invoice`, {
    params
  });
}
export function getPlan(params) {
  return api.get(`/billing/plan`, {
    params
  });
}
export function getUsage(params) {
  return api.get(`/billing/usage`, {
    params
  });
}
export function getQBCustomers(params) {
  return api.get(`/quickbooks/customers`, {
    params
  });
}
export function getContracts(params) {
  return api.get(`/billing/contract`, {
    params
  });
}
export function getContract(id) {
  return api.get(`/billing/contract/${id}`);
}
export function updateContract(id, data) {
  return api.patch(`/billing/contract/${id}`, data);
}
export function createContract(data) {
  return api.post(`/billing/contract`, data);
}
export function listContacts(params) {
  return api.get(`/billing/contact`, {
    params
  });
}
export function createContact(data) {
  return api.post(`/billing/contact`, data);
}
export function updateContact(id, data) {
  return api.patch(`/billing/contact/${id}`, data);
}
export function deleteContact(id) {
  return api.delete(`/billing/contact/${id}`);
}

/**
 * Billing Items
 */
export function getBillingItems(params) {
  return api.get(`/billing/items`, {
    params
  });
}
export function createBillingItem(data) {
  return api.post(`/billing/items`, data);
}
export function updateBillingItem(id, data) {
  return api.patch(`/billing/items/${id}`, data);
}
export function deleteBillingItem(id) {
  return api.delete(`/billing/items/${id}`);
}
export function archiveBillingItem(id) {
  return api.patch(`/billing/items/${id}/archive`);
}
export function unarchiveBillingItem(id) {
  return api.patch(`/billing/items/${id}/unarchive`);
}

/**
 * Billing Packages
 */
export function getBillingPackages(params) {
  return api.get(`/billing/packages`, {
    params
  });
}
export function createBillingPackage(data) {
  return api.post(`/billing/packages`, data);
}
export function updateBillingPackage(id, data) {
  return api.patch(`/billing/packages/${id}`, data);
}
export function deleteBillingPackage(id) {
  return api.delete(`/billing/packages/${id}`);
}
export function archiveBillingPackage(id) {
  return api.patch(`/billing/packages/${id}/archive`);
}
export function unarchiveBillingPackage(id) {
  return api.patch(`/billing/packages/${id}/unarchive`);
}

/**
 * Billing Discounts
 */
export function getBillingDiscounts(params) {
  return api.get(`/billing/discounts`, {
    params
  });
}
export function createBillingDiscount(data) {
  return api.post(`/billing/discounts`, data);
}
export function updateBillingDiscount(id, data) {
  return api.patch(`/billing/discounts/${id}`, data);
}
export function deleteBillingDiscount(id) {
  return api.delete(`/billing/discounts/${id}`);
}
export function archiveBillingDiscount(id) {
  return api.patch(`/billing/discounts/${id}/archive`);
}
export function unarchiveBillingDiscount(id) {
  return api.patch(`/billing/discounts/${id}/unarchive`);
}

/**
 * Billing Closers
 */
export function getClosers(params) {
  return api.get(`/billing/closers`, {
    params
  });
}
export function getClosersFromHubSpot(params) {
  return api.get(`/integration/hubspot/owners`, {
    params
  });
}
export function getHubspotOwnerById(id) {
  return api.get(`/integration/hubspot/owners/${id}`);
}
export function createCloser(data) {
  return api.post(`/billing/closers`, data);
}
export function updateCloser(id, data) {
  return api.patch(`/billing/closers/${id}`, data);
}
export function deleteCloser(id) {
  return api.delete(`/billing/closers/${id}`);
}

/**
 * Price Metrics
 */
export function getPriceMetrics(params) {
  return api.get(`/billing/price-metrics`, {
    params
  });
}
export function createPriceMetrics(data) {
  return api.post(`/billing/price-metrics`, data);
}
export function updatePriceMetrics(id, data) {
  return api.patch(`/billing/price-metrics/${id}`, data);
}
export function deletePriceMetrics(id) {
  return api.delete(`/billing/price-metrics/${id}`);
}

// Legacy aliases for backward compatibility
export const getUnitEconomics = getPriceMetrics;
export const createUnitEconomics = createPriceMetrics;
export const updateUnitEconomics = updatePriceMetrics;
export const deleteUnitEconomics = deletePriceMetrics;

/**
 * Contract Types
 */
export function getContractTypes(params) {
  return api.get(`/billing/contract-types`, {
    params
  });
}
export function createContractType(data) {
  return api.post(`/billing/contract-types`, data);
}
export function updateContractType(id, data) {
  return api.patch(`/billing/contract-types/${id}`, data);
}
export function deleteContractType(id) {
  return api.delete(`/billing/contract-types/${id}`);
}

/**
 *Stripe
 */

export function createStripeCustomerPortalSession(data) {
  return api.post(`/integration/stripe/self-serve/create-portal-session`, data);
}
export function createStripeCheckoutSession(data) {
  return api.post(`/integration/stripe/self-serve/create-checkout-session`, data);
}
export function getCheckoutSession(params) {
  return api.get(`/integration/stripe/self-serve/retrieve-checkout-session`, {
    params
  });
}
export function getStripeInvoices(params) {
  return api.get(`/integration/stripe/self-serve/list-invoices`, {
    params
  });
}
export function getBillingOverview(params) {
  return api.get(`/integration/stripe/self-serve/billing-overview`, {
    params
  });
}
export function getProductDetail(params) {
  return api.get(`/integration/stripe/self-serve/product-detail`, {
    params
  });
}
export function getPaymentInfo(params) {
  return api.get(`/integration/stripe/self-serve/payment-info`, {
    params
  });
}
export function getStripeSubscriptions(params) {
  return api.get(`/integration/stripe/self-serve/subscriptions`, {
    params
  });
}
export function getProductFamilies(params) {
  return api.get(`/integration/stripe/self-serve/product-families`, {
    params
  });
}
export function getStripeInvoiceDetails(params) {
  return api.get(`/integration/stripe/self-serve/retrieve-invoice`, {
    params
  });
}
export function isCompanyProvisioned(params) {
  return api.get(`/integration/stripe/self-serve/is-company-provisioned`, {
    params
  });
}
export function previewPlanChange(data) {
  return api.post(`/integration/stripe/self-serve/preview-plan-change`, data);
}
export function schedulePlanChange(data) {
  return api.post(`/integration/stripe/self-serve/upcoming-subscription-changes`, data);
}
export function cancelPendingPlanChange(id) {
  return api.delete(`/integration/stripe/self-serve/upcoming-subscription-changes/${id}`);
}
export function previewStripeSubscriptionQtyChange(data) {
  return api.post(`/integration/stripe/self-serve/preview-subscription-qty-change`, data);
}
export function changeStripeSubscriptionQty(data) {
  return api.post(`/integration/stripe/self-serve/change-subscription-qty`, data);
}
export function cancelStripeSubscription(data) {
  return api.post(`/integration/stripe/self-serve/cancel-subscription`, data);
}
export function reactivateStripeSubscription(data) {
  return api.post(`/integration/stripe/self-serve/reactivate-subscription`, data);
}
export function previewStripeSubscriptionSignup(data) {
  return api.post(`/integration/stripe/self-serve/preview-subscription-signup`, data);
}
export function getSubscriptionDebug(params) {
  return api.get(`/integration/stripe/self-serve/subscription-debug`, {
    params
  });
}